import { cn } from "../../../lib/cn";

const variantStyles = {
  default: "bg-white border border-surface-border",
  elevated: "bg-white border border-surface-border shadow-sm",
  outlined: "bg-transparent border border-surface-border",
  filled: "bg-surface border border-surface-border",
};

const radiusStyles = {
  sm: "rounded-lg",
  md: "rounded-xl",
  lg: "rounded-2xl",
  xl: "rounded-3xl",
};

/**
 * Card — unified surface container.
 * Replaces hand-rolled <div className="rounded-xl border bg-white p-..."> patterns.
 */
export const Card = ({
  variant = "default",
  radius = "md",
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={cn(
        "flex flex-col",
        variantStyles[variant],
        radiusStyles[radius],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

/**
 * CardHeader — top section with optional padding override.
 */
export const CardHeader = ({ className, children, ...props }) => (
  <div
    className={cn("px-6 py-4 border-b border-surface-border flex-shrink-0", className)}
    {...props}
  >
    {children}
  </div>
);

/**
 * CardBody — main content area, scrolls if overflow.
 */
export const CardBody = ({ className, children, ...props }) => (
  <div
    className={cn("p-6 flex-1 min-h-0", className)}
    {...props}
  >
    {children}
  </div>
);

/**
 * CardFooter — bottom section with border.
 */
export const CardFooter = ({ className, children, ...props }) => (
  <div
    className={cn("px-6 py-4 border-t border-surface-border flex-shrink-0", className)}
    {...props}
  >
    {children}
  </div>
);
